import {
  DigitalProductType,
  PhysicalProductType,
  ProductLink,
  ProductType,
} from 'organization/Event/Products/EventProductsProvider'
import {appLocaleToBcp47} from 'i18n/locales'
import {purchaseStatusLabel} from 'organization/Event/Products/Purchases/EventProductPurchasesProvider'
import {useI18n} from 'i18n/I18nContext'
import React from 'react'
import styled from 'styled-components'

export type PurchaseItemType = {
  id: number
  event_name: string
  description: string
  name: string
  links: ProductLink[]
  type: ProductType
  purchase_id: number
  purchase_date: string
  purchase_price: number | string
  purchase_status: string
  purchase_phone_number: string
  purchase_address: string
  purchase_name: string
}

export default function PurchaseItem(props: {product: PurchaseItemType}) {
  const {product} = props
  const {locale, t} = useI18n()

  return (
    <Card key={product.id}>
      <CardBody>
        <h3>{product.name} </h3>
        <p>
          № {product.purchase_id} /{' '}
          {new Date(product.purchase_date).toLocaleString(
            appLocaleToBcp47(locale),
          )}
          <br />
          {t('attendee.purchaseEventLabel')} <span>{product.event_name}</span>
          <br />
          {t('attendee.purchasePriceLabel')}{' '}
          <span>{product.purchase_price} €</span>
        </p>
        <div>
          {product.description.length > 10
            ? product.description.slice(0, 100) + ' ...'
            : product.description}
        </div>
      </CardBody>

      {product.type === DigitalProductType && (
        <CardBody>
          <h4>{t('attendee.purchaseDownloadLinks')}</h4>
          {product.links.map((link) => (
            <div key={link.url}>
              <ProdutLink
                href={link.url}
                target="_blank"
                rel="noreferrer"
                className="input__btn"
              >
                {link.name}
              </ProdutLink>
            </div>
          ))}
        </CardBody>
      )}

      {product.type === PhysicalProductType && (
        <CardBody>
          <h4>{t('attendee.purchaseShippingTitle')}</h4>
          <InfoBox>
            <label>{t('attendee.purchaseStatusLabel')}</label>
            <span>{purchaseStatusLabel(product.purchase_status, t)}</span>
          </InfoBox>
          {product.purchase_name && (
            <InfoBox>
              <label>{t('attendee.purchaseRecipientLabel')}</label>
              <span>{product.purchase_name}</span>
            </InfoBox>
          )}
          {product.purchase_phone_number && (
            <InfoBox>
              <label>{t('attendee.purchasePhoneLabel')}</label>
              <span>{product.purchase_phone_number}</span>
            </InfoBox>
          )}
          {product.purchase_address && (
            <InfoBox>
              <label>{t('attendee.purchaseAddressLabel')}</label>
              <span>{product.purchase_address}</span>
            </InfoBox>
          )}
        </CardBody>
      )}
    </Card>
  )
}

const InfoBox = styled.div`
  display: flex;
  justify-content: space-between;

  span {
    font-weight: 600;
  }
`

const ProdutLink = styled.a`
  margin-top: 10px;
  height: 35px;
`

const Card = styled.div`
  background: #f5f5f5;
  border-radius: 5px;
  overflow: hidden;
  transition: all 0.3s ease;
  position: relative;
`

const CardBody = styled.div`
  padding: 1.2rem 1.5rem;

  h3 {
    font-size: 1.1rem;
    font-weight: 600;
    color: ${({theme}) => theme?.colors?.textPrimary || '#222'};
    margin-bottom: 0.5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  h4 {
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: 0.6rem;
  }

  p {
    font-size: 0.9rem;
    color: ${({theme}) => theme?.colors?.textSecondary || '#777'};
    line-height: 1.4;

    span {
      color: ${({theme}) => theme?.colors?.textPrimary || '#111'};
      font-weight: 500;
    }
  }
`
